import { CallbackComponent } from './callback';

export const containers = [CallbackComponent];

export * from './callback';
